import styled from "styled-components";
import { Metrics } from "../../theme/index";
import ProgressSession from "./ProgressSession";
import Colors from "../../theme/Colors";

const LightCard = styled.div`
    padding-left: ${Metrics.card.paddingHorizontal/2}px;
    padding-right: ${Metrics.card.paddingHorizontal/2}px;
    padding-top: ${Metrics.card.paddingVertical/2}px;
    padding-bottom: ${Metrics.card.paddingVertical/2}px;
    border-radius: ${Metrics.boldBorderRadius}px;
    border: solid 
        ${props=>props.selected ? Metrics.selectedBorderWidth : Metrics.borderWidth}px 
        ${props=>props.selected ? props.theme.mainColor : Colors.lightBorderColor};
`;

export default {
	LightCard,
	ProgressSession
};


// WEBPACK FOOTER //
// ./src/components/card/index.js